import { Icon } from "armstrong-react";
import classnames from "classnames";
import React from "react";
import { LinkButton, DraggingContext } from "../../../../core/atoms/atoms";

interface FlexiProps {
  className: string;
  icomoon: string;
  title: string;
  description: string;
  cta: string;
  to: string;
  onClick?: () => void;
}

export class FlexiCard extends React.Component<FlexiProps> {
  public render() {
    return (
      <div className={classnames("content-card", "no-link", this.props.className)} onClick={this.props.onClick}>
        <Icon className="content-type-icon" icon={this.props.icomoon} />
        <h3>{this.props.title}</h3>
        <p className="text--body card-description">{this.props.description}</p>

        <DraggingContext.Consumer>
          {props => (
            <LinkButton {...props} to={this.props.to} className="primary-button heading--4 text--light">
              {this.props.cta}
            </LinkButton>
          )}
        </DraggingContext.Consumer>
      </div>
    );
  }
}
